/**
 * App-wide configuration
 */

// API Configuration
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://randstad-jobcoach-backend-480251619774.europe-west1.run.app/api";

// Gemini Model Configuration
export const GEMINI_MODEL = "gemini-2.5-flash-native-audio-preview-12-2025";

// Conversation Configuration
export const DEFAULT_VOICE = "Leda";

// Language configuration per country
const LANGUAGE_CONFIG: Record<
  string,
  { default: string; available: string[] }
> = {
  PL: {
    default: "Polish",
    available: ["Polish", "English"],
  },
  BE: {
    default: "Flemish",
    available: ["Flemish", "English"],
  },
  DEMO: {
    default: "English",
    available: ["English", "Polish", "Flemish"],
  },
};

export const DEFAULT_LANGUAGE = "English";
export const AVAILABLE_LANGUAGES = ["English", "Flemish", "Polish"];

export const getDefaultLanguage = (countryCode: string): string => {
  return LANGUAGE_CONFIG[countryCode]?.default ?? DEFAULT_LANGUAGE;
};

export const getAvailableLanguages = (countryCode: string): string[] => {
  return LANGUAGE_CONFIG[countryCode]?.available ?? AVAILABLE_LANGUAGES;
};
